import React, { useCallback } from 'react';

import { Textarea, Flexer, Button } from '@ontruck/orc';

import ShipperOrderTag from 'modules/shipper-order/Tag';

import { StyledItem } from 'modules/log/LogItem/styled';

import ActionName from 'modules/log/LogItem/modes/common/ActionName';

import useEditionMode from 'modules/log/LogItem/modes/common/useEditionMode';
import { injectIntl } from 'react-intl';

const EditMode = ({
  comment,
  action,
  shipperOrdersSkin = {},
  journey_id,
  shipper_order_id,
  onSubmit,
  onCancel,
  id,
  intl,
}) => {
  const multipleShipperOrders = Object.keys(shipperOrdersSkin || {}).length > 1;
  const t = intl.messages.modules.logs.log_item;
  const {
    comment: commentEdited,
    handleTextareaChange,
    textAreaRef,
  } = useEditionMode({
    defaultComment: comment,
  });

  const handleSaveClick = useCallback(() => {
    onSubmit &&
      onSubmit({
        id,
        journeyId: journey_id,
        shipperOrderId: shipper_order_id,
        comment: commentEdited,
        type: 'inlineEdit',
      });
  }, [id, journey_id, shipper_order_id, commentEdited, onSubmit]);

  const saveButtonText = t.save_entry;
  const saveButtonDisabled = comment === commentEdited;

  return (
    <StyledItem background="grey200">
      <Flexer.Parent alignItems="center" mBottom="XS">
        <Flexer.Child flex="1">
          <ActionName action={action} bold color="grey900" />
        </Flexer.Child>
        {multipleShipperOrders && shipper_order_id && (
          <Flexer.Child mLeft="XS">
            <ShipperOrderTag
              id={shipper_order_id}
              shipperOrdersSkin={shipperOrdersSkin}
              withinGroupage
            />
          </Flexer.Child>
        )}
      </Flexer.Parent>
      <Textarea
        fullWidth
        value={commentEdited}
        labelType="hidden"
        height={'100px'}
        width={'100%'}
        onChange={handleTextareaChange}
        placeholder={t.textarea_placeholder}
        fieldRef={textAreaRef}
      />
      <Flexer.Parent mTop="S" mBottom="XS" justifyContent="flex-end">
        <Flexer.Child>
          <Button skin="secondary" nude text={t.cancel} onClick={onCancel} />
        </Flexer.Child>
        <Flexer.Child>
          <Button
            skin="primary"
            text={saveButtonText}
            disabled={saveButtonDisabled}
            onClick={handleSaveClick}
          />
        </Flexer.Child>
      </Flexer.Parent>
    </StyledItem>
  );
};

export default injectIntl(EditMode);
